import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhone, faWeixin } from '@fortawesome/free-solid-svg-icons';
import { faWeixin as faWeixinBrand } from '@fortawesome/free-brands-svg-icons';

const CompanyInfo = ({ title = "联系我们", description = "扫描二维码添加销售微信，获取专业咨询" }) => {
  return (
    <div className="bg-white rounded-3xl shadow-2xl p-8 lg:p-12">
      <div className="text-center mb-8">
        <h3 className="text-2xl font-bold text-gray-900 mb-4">{title}</h3>
        <p className="text-gray-600">{description}</p>
      </div>
      
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12">
        {/* 联系电话 */}
        <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow duration-300">
          <div className="text-center">
            <div className="w-16 h-16 bg-gradient-primary rounded-full flex items-center justify-center mx-auto mb-6">
              <FontAwesomeIcon icon={faPhone} className="text-white text-2xl" />
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-4">24小时服务热线</h3>
            <div className="text-3xl font-bold gradient-text mb-4">0558-5555435</div>
            <p className="text-gray-600 leading-relaxed">
              专业客服团队为您提供全天候技术支持与咨询服务
            </p>
          </div>
        </div>

        {/* 微信联系 */}
        <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow duration-300">
          <div className="text-center">
            <h3 className="text-2xl font-bold text-gray-900 mb-6">添加销售顾问微信</h3>
            <div className="flex justify-center mb-6">
              <div className="w-32 h-32 bg-gray-100 rounded-lg flex items-center justify-center border-2 border-dashed border-gray-300">
                <img 
                  src="/service.png" 
                  alt="销售顾问微信二维码" 
                  className="w-28 h-28 object-contain"
                />
              </div>
            </div>
            <p className="text-gray-600 leading-relaxed">
              扫描二维码获取一对一专业咨询服务
            </p>
          </div>
        </div>
      </div>
      
      {/* 服务说明 */}
      <div className="mt-8 p-6 bg-blue-50 rounded-2xl">
        <div className="text-center">
          <h5 className="text-lg font-bold text-gray-900 mb-2">专业服务承诺</h5>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 text-sm text-gray-600">
            <div className="flex items-center justify-center">
              <span className="w-2 h-2 bg-primary-blue rounded-full mr-2"></span>
              24小时内响应
            </div>
            <div className="flex items-center justify-center">
              <span className="w-2 h-2 bg-primary-blue rounded-full mr-2"></span>
              专业顾问一对一服务
            </div>
            <div className="flex items-center justify-center">
              <span className="w-2 h-2 bg-primary-blue rounded-full mr-2"></span>
              免费产品演示
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CompanyInfo;